/* eslint-disable complexity */
import React from 'react'
import AwsConfig from '../../Config/AwsConfig'
function CastAndCrew(props) {
  const {
    path,
    readmorecast,
    localValue,
    displayNoneStyle,
    singleClickcrew,
    singleClickcast,
    displayNoneStyleCast,
    Doubleclickchip,
  } = props
  return path !== 'genre_En' &&
    path !== 'genre_Te' &&
    path !== 'ottPlatform' &&
    path !== 'movieCast' &&
    path !== 'movieStoryBy' &&
    path !== 'movieScreenplayBy' &&
    path !== 'movieWrittenBy' &&
    path !== 'movieDialogueBy' &&
    path !== 'movieMusicBy' &&
    path !== 'movieEditedBy' &&
    path !== 'movieCinematography' &&
    path !== 'movieProducedBy' &&
    path !== 'movieDirectedBy'
    ? readmorecast
      ? path === 'genre_En' || path === 'genre_Te' || path === 'ottPlatform'
        ? ''
        : localValue.map((item, index) => (
            <div
              className={
                item.isAnonymous
                  ? item.name_Te === null ||
                    // item.posterURL === null ||
                    item.name_Te === undefined
                    ? 'd-none'
                    : ' castchipboxred d-flex'
                  : ' castchipbox d-flex'
              }
              key={index}
            >
              <img
                className='imgchip'
                style={
                  item.posterURL === null && item.posterURL === undefined && item.name_Te === null
                    ? displayNoneStyle.main
                    : null
                }
                src={
                  item.posterURL === null || item.posterURL === undefined
                    ? null
                    : AwsConfig.movieCdnUrl + item.posterURL
                }
              />
              <div className='chipForCast' key={index}>
                {path === 'movieCast_Te' ? (
                  item.name_Te === null ? (
                    ''
                  ) : (
                    <div
                      onDoubleClick={() => Doubleclickchip(item.personID)}
                      className='moviecastHeight'
                      style={
                        item.posterURL === null &&
                        item.posterURL === undefined &&
                        item.name_Te === null
                          ? displayNoneStyleCast.main
                          : null
                      }
                    >
                      <div>{item.name_Te}</div>
                      <div style={{ marginLeft: '2px' }}></div>
                      <div
                        onClick={() => singleClickcast(localValue, item.personID, item.roleName_Te)}
                      >
                        {item.roleName_Te === null || item.roleName_Te === undefined ? (
                          ''
                        ) : (
                          <div> గా {item.roleName_Te}</div>
                        )}
                      </div>
                    </div>
                  )
                ) : (
                  <div onClick={() => singleClickcast(localValue, item.personID, item.roleName_Te)}>
                    {item.name_Te}
                  </div>
                )}
              </div>
            </div>
          ))
      : path === 'genre_En' || path === 'ottPlatform'
      ? ''
      : localValue.slice(0, 10).map((item, index) => (
          <div
            className={
              item.isAnonymous
                ? item.name_Te === null || item.name_Te === undefined
                  ? ''
                  : 'castchipboxred d-flex'
                : ' castchipbox d-flex'
            }
            key={index}
          >
            <img
              className='imgchip'
              style={
                item.posterURL === null && item.posterURL === undefined && item.name_Te === null
                  ? displayNoneStyle.main
                  : null
              }
              src={
                item.posterURL === null || item.posterURL === undefined
                  ? null
                  : AwsConfig.movieCdnUrl + item.posterURL
              }
            />{' '}
            <div className='chipForCast' key={index}>
              {path === 'movieCast_Te' ? (
                item.name_Te === null ? (
                  ''
                ) : (
                  <div
                    onDoubleClick={() => Doubleclickchip(item.personID)}
                    className='moviecastHeight'
                    style={
                      item.posterURL === null &&
                      item.posterURL === undefined &&
                      item.name_Te === null
                        ? displayNoneStyleCast.main
                        : null
                    }
                  >
                    <div>{item.name_Te}</div>
                    <div style={{ marginLeft: '2px' }}></div>
                    <div
                      onClick={() => singleClickcast(localValue, item.personID, item.roleName_Te)}
                    >
                      {item.roleName_Te === null || item.roleName_Te === undefined ? (
                        ''
                      ) : (
                        <div> గా {item.roleName_Te}</div>
                      )}
                    </div>
                  </div>
                )
              ) : (
                <div
                  onClick={() =>
                    singleClickcrew(localValue, item.personID, item.name_Te, item.isAnonymous)
                  }
                >
                  {item.name_Te}
                </div>
              )}
            </div>
          </div>
        ))
    : path === 'genre_En' || path === 'ottPlatform'
    ? ''
    : readmorecast
    ? localValue.map((item, index) => (
        <div
          className={item.isAnonymous ? ' castchipboxred d-flex' : ' castchipbox d-flex'}
          key={index}
        >
          <img
            className='imgchip'
            style={
              item.posterURL === null && item.posterURL === undefined && item.name_En === null
                ? displayNoneStyle.main
                : null
            }
            src={
              item.posterURL === null || item.posterURL === undefined
                ? null
                : AwsConfig.movieCdnUrl + item.posterURL
            }
          />
          <div className='chipForCast' key={index}>
            {path === 'movieCast' ? (
              item.name_En === null ? (
                ''
              ) : (
                <div
                  onDoubleClick={() => Doubleclickchip(item.personID)}
                  className='moviecastHeight'
                  style={
                    item.posterURL === null && item.posterURL === undefined && item.name_Te === null
                      ? displayNoneStyleCast.main
                      : null
                  }
                >
                  <div>{item.name_En}</div>
                  <div style={{ marginLeft: '2px' }}></div>
                  <div onClick={() => singleClickcast(localValue, item.personID, item.roleName_En)}>
                    {item.roleName_En}
                  </div>
                </div>
              )
            ) : (
              <div onClick={() => singleClickcast(localValue, item.personID, item.roleName_En)}>
                {item.name_En}
              </div>
            )}
          </div>
        </div>
      ))
    : path === 'genre_En' || path === 'genre_Te' || path === 'ottPlatform'
    ? ''
    : localValue.slice(0, 10).map((item, index) => (
        <div
          className={item.isAnonymous ? ' castchipboxred d-flex' : ' castchipbox d-flex'}
          key={index}
        >
          {' '}
          <img
            className='imgchip'
            style={
              item.posterURL === null && item.posterURL === undefined && item.name_En === null
                ? displayNoneStyle.main
                : null
            }
            src={
              item.posterURL === null || item.posterURL === undefined
                ? null
                : AwsConfig.movieCdnUrl + item.posterURL
            }
          />
          <div className='chipForCast' key={index}>
            {path === 'movieCast' ? (
              item.name_En === null ? (
                ''
              ) : (
                <div
                  onDoubleClick={() => Doubleclickchip(item.personID)}
                  className='moviecastHeight'
                  style={
                    item.posterURL === null && item.posterURL === undefined && item.name_Te === null
                      ? displayNoneStyleCast.main
                      : null
                  }
                >
                  <div>{item.name_En}</div>
                  <div style={{ marginLeft: '2px' }}></div>
                  <div onClick={() => singleClickcast(localValue, item.personID, item.roleName_En)}>
                    {item.roleName_En}
                  </div>
                </div>
              )
            ) : (
              <div
                onClick={() =>
                  singleClickcrew(localValue, item.personID, item.name_En, item.isAnonymous)
                }
              >
                {item.name_En}
              </div>
            )}
          </div>
        </div>
      ))
}

export default CastAndCrew
